import request from '@/helpers/request'

export default {
    getArticles: (pageSize, pageNumber, excludeArticleId, isGiftList) => request.get(`/GetArticles?pageSize=${pageSize}&pageNumber=${pageNumber}&excludeArticleId=${excludeArticleId}&isGiftList=${isGiftList}`),
    getArticleDetails: (articleId, includeDeals) => request.get(`/GetArticleDetails?articleId=${articleId}&includeDeals=${includeDeals}`),
    getLatestDeals: (pageSize, pageNumber, excludeDeal) => request.get(`/GetLatestDeals?pageSize=${pageSize}&pageNumber=${pageNumber}&excludeDeal=${excludeDeal}`),
    submitContactUsForm: (form) => request.post('/SubmitContactUsForm', form),
    newsletterSignup: (form) => request.post('/NewsletterSignup', form),
    getDealsByDate: (pageSize, pageNumber, excludeDeal, date) => request.get(`/GetDealsByDate?pageSize=${pageSize}&pageNumber=${pageNumber}&excludeDeal=${excludeDeal}&date=${date}`),
    getDeal: (dealId) => request.get(`/GetDeal?dealId=${dealId}`),
    getGiveawayInfo: (ParticipantHash) => request.get(`/GetGiveawayInfo?ParticipantHash=${ParticipantHash}`),
    newGiveawayEntry: (newEntry) => request.post('/NewGiveawayEntry', newEntry),

    ////////
    postToFacebookPage: (data) => request.post('/PostToFacebookPage', data),
    postToFacebookGroup: (data) => request.post('/PostToFacebookGroup', data),
    postToTwitter: (data) => request.post('/PostToTwitter', data),
    postToTwitter2: function (data) { request.post('/PostToTwitter', data); },
    postToTelegram: (data) => request.post('/PostToTelegram', data),
    getJCNAd: (zid, pid) => request.getExternal(`https://servedby.jewishcontentnetwork.com/servlet/view/banner/url/zone?zid=${zid}&pid=${pid}`),
    googleAccessTokens: () => request.get('/googleAccessTokens'),
    googleGetRealTimeData: (params, headers) => request.getExternal(`https://www.googleapis.com/analytics/v3/data/realtime?${params}`, headers),
    analysis: {
        searchAnalytics: (data) => request.post('/analysis/analytics', data),
        searchOrderHistory: (data) => request.post('/analysis/orderHistory', data)
    }
    
}